module.exports = "././img/omi_logo_white.png";


//////////////////
// WEBPACK FOOTER
// ../assets/img/omi_logo_white.png
// module id = 823
// module chunks = 0